"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var BlackListObfuscatingGuard_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlackListObfuscatingGuard = void 0;
const inversify_1 = require("inversify");
const ObfuscatingGuardResult_1 = require("../../../enums/node/ObfuscatingGuardResult");
const NodeGuards_1 = require("../../../node/NodeGuards");
let BlackListObfuscatingGuard = BlackListObfuscatingGuard_1 = class BlackListObfuscatingGuard {
    constructor() {
        this.blackListGuardsLength = BlackListObfuscatingGuard_1.blackListGuards.length;
    }
    check(node) {
        for (let i = 0; i < this.blackListGuardsLength; i++) {
            if (BlackListObfuscatingGuard_1.blackListGuards[i](node)) {
                return ObfuscatingGuardResult_1.ObfuscatingGuardResult.Ignore;
            }
        }
        return ObfuscatingGuardResult_1.ObfuscatingGuardResult.Transform;
    }
};
exports.BlackListObfuscatingGuard = BlackListObfuscatingGuard;
BlackListObfuscatingGuard.blackListGuards = [NodeGuards_1.NodeGuards.isDirectiveNode];
exports.BlackListObfuscatingGuard = BlackListObfuscatingGuard = BlackListObfuscatingGuard_1 = __decorate([
    (0, inversify_1.injectable)(),
    __metadata("design:paramtypes", [])
], BlackListObfuscatingGuard);
